// Real Kamakhya Cosmetics catalog, built from the label artwork supplied by
// the client (Alpha Print Pack print proofs + in-house PSD/AI files).
// This is still static/local data — the storefront isn't wired up to the
// backend API yet, so these ids are just local numbers, not MongoDB _ids.
// Once the storefront is connected to the backend, this file goes away and
// products load from the API instead (which is also where the *real*,
// permanent barcode for each product lives).

import toiletCleanerFront from '../assets/products/shine-toilet-cleaner/front.png'
import toiletCleanerBack from '../assets/products/shine-toilet-cleaner/back.png'

import glycerin50Front from '../assets/products/royal-luxury-glycerin-50gm/front.png'
import glycerin50Back from '../assets/products/royal-luxury-glycerin-50gm/back.png'

import glycerin100Front from '../assets/products/royal-luxury-glycerin-100gm/front.png'
import glycerin100Back from '../assets/products/royal-luxury-glycerin-100gm/back.png'

import haldiChandanFront from '../assets/products/royal-luxury-haldi-chandan-face-wash/front.png'
import haldiChandanBack from '../assets/products/royal-luxury-haldi-chandan-face-wash/back.png'

import lipGuardMint from '../assets/products/royal-luxury-lip-guard-mint/label.png'
import lipGuardPetroleumJelly from '../assets/products/royal-luxury-lip-guard-petroleum-jelly/label.png'
import lipGuardStrawberry from '../assets/products/royal-luxury-lip-guard-strawberry/label.png'

import neemAloeFront from '../assets/products/royal-luxury-neem-aloe-vera-face-wash/front.png'
import neemAloeBack from '../assets/products/royal-luxury-neem-aloe-vera-face-wash/back.png'

import papayaFront from '../assets/products/royal-luxury-papaya-face-wash/front.png'
import papayaBack from '../assets/products/royal-luxury-papaya-face-wash/back.png'

import floorCleanerFront from '../assets/products/shine-floor-cleaner/front.png'
import floorCleanerBack from '../assets/products/shine-floor-cleaner/back.png'

import laundryDetergentFront from '../assets/products/shine-laundry-detergent/front.png'
import laundryDetergentBack from '../assets/products/shine-laundry-detergent/back.png'

import dishWashLabel from '../assets/products/shine-dish-wash/label.png'

import blackPhenylFront from '../assets/products/shine-black-phenyl/front.png'
import blackPhenylBack from '../assets/products/shine-black-phenyl/back.png'

export const products = [
    {
        id: 1,
        tag: 'SHINE',
        brand: 'Shine',
        category: 'Bathroom Cleaners',
        type: 'Featured',
        image: toiletCleanerFront,
        images: [toiletCleanerFront, toiletCleanerBack],
        title: 'Toilet Cleaner',
        desc: 'Gives you a completely clean toilet from rim to U-bend, with 5 times better cleaning than ordinary cleaners and 99.9% germ kill.',
        moq: '300 pcs',
        lead: '5-7 days',
    },
    {
        id: 2,
        tag: 'ROYAL LUXURY',
        brand: 'Royal Luxury',
        category: 'Body Care',
        type: 'Best Seller',
        image: glycerin50Front,
        images: [glycerin50Front, glycerin50Back],
        title: 'Glycerin 99.9% Pure Vegetable - 50gm',
        desc: 'A natural daily moisturizer for softening and protecting dry, damaged hair, scalp and skin. Excellent for body massages, blackhead removal and skin brightening.',
        moq: '300 pcs',
        lead: '5-7 days',
    },
    {
        id: 3,
        tag: 'ROYAL LUXURY',
        brand: 'Royal Luxury',
        category: 'Body Care',
        type: 'Best Seller',
        image: glycerin100Front,
        images: [glycerin100Front, glycerin100Back],
        title: 'Glycerin 99.9% Pure Vegetable - 100gm',
        desc: 'A natural daily moisturizer for softening and protecting dry, damaged hair, scalp and skin. Excellent for body massages, blackhead removal and skin brightening.',
        moq: '300 pcs',
        lead: '5-7 days',
    },
    {
        id: 4,
        tag: 'ROYAL LUXURY',
        brand: 'Royal Luxury',
        category: 'Face Care',
        type: 'Featured',
        image: haldiChandanFront,
        images: [haldiChandanFront, haldiChandanBack],
        title: 'Haldi Chandan Skin Glowing Face Wash',
        desc: 'A time-tested combination of Haldi and Chandan extract lifts away impurities, leaving a smooth, clean complexion. Pimple-free, glowing skin for all skin types.',
        moq: '300 pcs',
        lead: '5-7 days',
    },
    {
        id: 5,
        tag: 'ROYAL LUXURY',
        brand: 'Royal Luxury',
        category: 'Lip Care',
        type: 'Signatured Products',
        image: lipGuardMint,
        images: [lipGuardMint],
        title: 'Lip Guard - Refreshing Mint',
        desc: 'A nourishing blend of cosmetic petroleum, botanical oils and shea butter infused with peppermint oil. Deeply moisturizes and soothes dry, cracked lips.',
        moq: '500 pcs',
        lead: '5-7 days',
    },
    {
        id: 6,
        tag: 'ROYAL LUXURY',
        brand: 'Royal Luxury',
        category: 'Lip Care',
        type: 'Signatured Products',
        image: lipGuardPetroleumJelly,
        images: [lipGuardPetroleumJelly],
        title: 'Lip Guard - White Petroleum Jelly Classic',
        desc: 'Infused with natural oils and Vitamin E, this squeeze-gel formula intensely nourishes and protects with a classic white petroleum jelly finish.',
        moq: '500 pcs',
        lead: '5-7 days',
    },
    {
        id: 7,
        tag: 'ROYAL LUXURY',
        brand: 'Royal Luxury',
        category: 'Lip Care',
        type: 'Signatured Products',
        image: lipGuardStrawberry,
        images: [lipGuardStrawberry],
        title: 'Lip Guard - Strawberry',
        desc: 'Infused with natural Strawberry Seed Oil and Vitamin E, this squeeze-gel formula nourishes and protects with a juicy strawberry flavor and subtle tint.',
        moq: '500 pcs',
        lead: '5-7 days',
    },
    {
        id: 8,
        tag: 'ROYAL LUXURY',
        brand: 'Royal Luxury',
        category: 'Face Care',
        type: 'Featured',
        image: neemAloeFront,
        images: [neemAloeFront, neemAloeBack],
        title: 'Neem & Aloe Vera Skin Purifying Face Wash',
        desc: 'A time-tested combination of Neem and Aloe Vera with Tea Tree Oil purifies skin, leaving it clean, pure, silky-smooth and radiant.',
        moq: '300 pcs',
        lead: '5-7 days',
    },
    {
        id: 9,
        tag: 'ROYAL LUXURY',
        brand: 'Royal Luxury',
        category: 'Face Care',
        type: 'Featured',
        image: papayaFront,
        images: [papayaFront, papayaBack],
        title: 'Papaya Skin Whitening Face Wash',
        desc: 'A time-tested combination of Papaya Extract and Licorice Extract purifies skin, leaving it clean, pure, silky-smooth and radiant.',
        moq: '300 pcs',
        lead: '5-7 days',
    },
    {
        id: 10,
        tag: 'SHINE',
        brand: 'Shine',
        category: 'Floor and Surface Cleaners',
        type: 'Best Seller',
        image: floorCleanerFront,
        images: [floorCleanerFront, floorCleanerBack],
        title: 'Disinfectant Surface Cleaner 500ml',
        desc: 'A unique formulation that kills 99.9% of germs and removes tough stains, leaving a pleasant lemon fragrance. Safe for use on all floors, pets and home.',
        moq: '300 pcs',
        lead: '5-7 days',
    },
    {
        id: 11,
        tag: 'SHINE',
        brand: 'Shine',
        category: 'Laundry',
        type: 'Best Seller',
        image: laundryDetergentFront,
        images: [laundryDetergentFront, laundryDetergentBack],
        title: 'Laundry Detergent 1000ml',
        desc: 'A 3X concentrated formula for powerful clean and fresh fragrance. Deep cleans and brightens fabrics with non-toxic ingredients.',
        moq: '300 pcs',
        lead: '5-7 days',
    },
    {
        id: 12,
        tag: 'SHINE',
        brand: 'Shine',
        category: 'Kitchen & Dishwashing',
        type: 'Featured',
        image: dishWashLabel,
        images: [dishWashLabel],
        title: 'Dish Wash Liquid',
        desc: 'An effective and powerful dish wash formula that cuts tough grease residue, removes foul smell and leaves sparkling clean utensils.',
        moq: '300 pcs',
        lead: '5-7 days',
    },
    {
        id: 13,
        tag: 'SHINE',
        brand: 'Shine',
        category: 'Floor and Surface Cleaners',
        type: 'Featured',
        image: blackPhenylFront,
        images: [blackPhenylFront, blackPhenylBack],
        title: 'Black Phenyl 900ml',
        desc: 'An insecticidal and disinfectant floor cleaner and spray that repels snakes and insects, ideal for homes, hotels, hospitals and schools.',
        moq: '300 pcs',
        lead: '5-7 days',
    },
]
